import moment, { Moment } from 'moment';

export function findAge(dateOfBirth: string): number {
  return moment().diff(convertToMoment(dateOfBirth, 'YYYY-MM-DD'), 'years');
}

export function isBirthdateMinor(dateOfBirth: string): boolean {
  return moment().diff(dateOfBirth, 'years', true) < 18;
}

export function getNowDateString(): string {
  return moment().format('YYYY-MM-DD');
}

export function getUtcNowDate(): Moment {
  return moment.utc();
}

export function getUtcNowString(format?: string): string {
  return moment.utc().format(format);
}

export function convertToMoment(dateString?: string, format?: string): Moment {
  return moment(dateString ?? '', format);
}

export function convertToMomentUtc(dateString?: string): Moment {
  return moment.utc(dateString ?? '');
}

export function localUtcDate(): Moment {
  return moment(moment.utc()).local();
}

export function convertUtcToLocal(utcDate: string): Moment {
  return moment(moment.utc(utcDate)).local();
}

export function formatLocal(utcDate: string, format: string): string {
  return moment(utcDate).local().format(format);
}

export function formatUtcToLocal(utcDate: string, format: string): string {
  return moment(moment.utc(utcDate)).local().format(format);
}

export function formatUtcToLocalDateTime(utcDate: string): string {
  return moment(moment.utc(utcDate)).local().format('dddd, MMM Do YYYY @ h:mm a');
}

export function formatDateTime(dateTime: string, format: string): string {
  return moment(dateTime).format(format);
}
